import { useRef, useState } from "react";

/**
 * Reusable 3D tilt wrapper. Applies rotateX/rotateY on mousemove.
 * intensity: degrees of max tilt.
 */
export default function TiltCard({
    children,
    className = "",
    intensity = 10,
    scale = 1.02,
    lift = 12,
    ...rest
}) {
    const ref = useRef(null);
    const [style, setStyle] = useState({});

    const handleMove = (e) => {
        const el = ref.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        setStyle({
            transform: `perspective(1000px) rotateY(${x * intensity * 2}deg) rotateX(${
                -y * intensity * 2
            }deg) translateZ(${lift}px) scale(${scale})`,
        });
    };
    const handleLeave = () => {
        setStyle({
            transform:
                "perspective(1000px) rotateY(0deg) rotateX(0deg) translateZ(0px) scale(1)",
        });
    };

    return (
        <div
            ref={ref}
            onMouseMove={handleMove}
            onMouseLeave={handleLeave}
            className={`tilt-card ${className}`}
            style={style}
            {...rest}
        >
            {children}
        </div>
    );
}
